<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />ข้อมูลพื้นฐานโครงการ
    </h6>

    <table class="table mb-0">
      <tbody>
        <tr v-if="value.signedDoc">
          <td class="align-middle">
            <strong>เอกสารจาก e-Office</strong>
          </td>
          <td class="align-middle">
            <a :href="fileUrl">ดาวน์โหลด</a>
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ชื่อโครงการ</strong>
          </td>
          <td class="align-middle">
            {{ value.name }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>หน่วยงานที่รับผิดชอบ</strong>
          </td>
          <td class="align-middle">
            {{ value.group.name }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ปีการศึกษา</strong>
          </td>
          <td class="align-middle">
            <span v-if="value.acYear">ปีการศึกษา {{ value.acYear.year }}</span>
            <span v-else>ไม่มีข้อมูล</span>
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ที่ปรึกษา</strong>
            <p>ข้อมูลอัตโนมัติจากหน่วยงานที่รับผิดชอบ</p>
          </td>
          <td class="align-middle">
            {{ value.advisor.name ? value.advisor.name : 'ไม่ได้ระบุ' }} {{ value.advisor.tel ? '(โทร ' + value.advisor.tel + ')' : '' }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ประธานโครงการ</strong>
          </td>
          <td class="align-middle">
            {{ value.leader.name ? value.leader.name : 'ไม่ได้ระบุ' }} {{ value.leader.tel ? '(โทร ' + value.leader.tel + ')' : '' }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>ผู้ประสานงานโครงการ</strong>
          </td>
          <td class="align-middle">
            <coordinators-table v-model="value.coordinators" :edit-mode="false" />
          </td>
        </tr>
        <tr v-if="$auth.user().role === 'osda'">
          <td>
            <strong>ผู้สร้างโครงการ</strong>
          </td>
          <td class="align-middle">
            {{ value.author.username }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>อาจารย์ผู้ดูแลโครงการ</strong>
            <p>กรณีที่ผู้ดูแลโครงการไม่ใช่อาจารย์ที่ปรึกษา</p>
          </td>
          <td class="align-middle">
            {{ value.personInCharge }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>หลักการและเหตุผล</strong>
          </td>
          <td class="align-middle" v-html="value.background" />
        </tr>
        <tr>
          <td>
            <strong>วัตถุประสงค์</strong>
          </td>
          <td class="align-middle">
            <objective-list v-model="value.objectives" :edit-mode="false" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>สถานที่จัดโครงการ</strong>
          </td>
          <td class="align-middle">
            <venue-list v-model="value.venue" :edit-mode="false" />
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>วันจัดโครงการ</strong>
          </td>
          <td class="align-middle">
            {{ value.timeframe }}
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ผู้เข้าร่วมโครงการ</strong>
          </td>
          <td class="align-middle">
            <div class="row">
              <div class="col">
                <ul class="mb-0 pl-3">
                  <li>อาจารย์/เจ้าหน้าที่ {{ value.attendee.instructor }} คน</li>
                  <li>นักศึกษา {{ value.attendee.student }} คน</li>
                  <li>บุคคลภายนอก {{ value.attendee.others }} คน</li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import CoordinatorsTable from './CoordinatorTable'
import ObjectiveList from './ObjectiveList'
import VenueList from './VenueList'

export default {
  components: {
    CoordinatorsTable, ObjectiveList, VenueList
  },
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      //
    }
  },
  computed: {
    totalAttendee () {
      return this.value.attendee.instructor + this.value.attendee.student + this.value.attendee.others
    },
    fileUrl () {
      return process.env.VUE_APP_FILE_BASE_URL + '/' + this.value.signedDoc
    },
    checkingStatus () {
      switch (this.value.checkingStatus) {
        case 'Pending':
          return 'รอออกเช็ค'
        case 'Issued':
          return 'ออกเช็คแล้ว'
        case 'Cancelled':
          return 'ยกเลิกเช็ค'
        default:
          return 'ไม่อนุมัติงบประมาณ'
      }
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
